import { useSyncExternalStore } from "react"

import { canUseWebShare } from "@/lib/web-share"

const subscribe = () => () => undefined
const getServerSnapshot = () => false

/**
 * Web Share support is static for the lifetime of a page. Using an external
 * store snapshot keeps server rendering false and refreshes the value after
 * hydration without a state-setting effect.
 */
export function useWebShareSupport(): boolean {
  return useSyncExternalStore(subscribe, canUseWebShare, getServerSnapshot)
}
